module.exports = __webpack_public_path__ + "static/media/8th_D.889b9d82.png";